<template>
<div class="burns">
        <canvas id="chart"></canvas>
    </div>
</template>

<script>
import { Chart, LinearScale } from "chart.js";
import { SankeyController, Flow } from "chartjs-chart-sankey";

Chart.register(LinearScale, SankeyController, Flow);

export default {
    name: "FeeBurn",
    props: ['total','base','priority','vote','currentEpoch','jito','validators'],
    mounted: function() {
        let dynamicValidatorLabel = "1.3k+ Validators";
/*
        if (this.currentEpoch >= 741) {
            const validatorCount = Array.isArray(this.validators) ? String(this.validators.length) : "0";
            dynamicValidatorLabel = `1.5k+ Validators`;
            console.log(dynamicValidatorLabel)
        }
*/

        var ctx = document.getElementById("chart").getContext("2d");

        var colors = {
            "🤖 Validator Rewards":  "#55ff00",
            "🔥 Burned": "#FF0000",
            "Base Fees": '#ffc400',
            "Priority Fees": '#ff6a00',
            "Vote Fees": '#06f8ff',
            "Jito Tips": "rgb(185 107 252)",
            "Jito DAO": "#ffa500",
            "475k+ Stakers": "#00aaff"
        };

        function getColor(name) {
            return colors[name] || "green";
        }
        let config = {
            type: "sankey",
            data: {
                datasets: [
                    {
                        data: (() => {

                            let feesTotal = this.base + this.priority;
                            let flows = [];
                            if (this.currentEpoch < 741) {
                                flows.push({ from: "Priority Fees", to: "🔥 Burned", flow: this.priority/2 });
                                flows.push({ from: "Priority Fees", to: "🤖 Validator Rewards", flow: this.priority/2 });
                                flows.push({ from: "Base Fees", to: "🔥 Burned", flow: this.base/2 });
                                flows.push({ from: "Base Fees", to: "🤖 Validator Rewards", flow: this.base/2 });
                                flows.push({ from: "Vote Fees", to: "🔥 Burned", flow: this.vote/2 });
                                flows.push({ from: "Vote Fees", to: "🤖 Validator Rewards", flow: this.vote/2 });
                            } else {
                                // Use the dynamic label computed above
                                let feesTotal = this.base + this.priority;
                                flows.push({ from: "Total Revenue", to: "Jito Tips", flow: this.jito });
                                flows.push({ from: "Total Revenue", to: "Fees", flow: feesTotal });
                                flows.push({ from: "Jito Tips", to: "Jito DAO", flow: this.jito * 0.05 });
                                flows.push({ from: "Jito Tips", to: "1.3k+ Validators", flow: this.jito * 0.95 * 0.10 });
                                flows.push({ from: "Jito Tips", to: "475k+ Stakers", flow: this.jito * 0.95 * 0.90 });
                                flows.push({ from: "Fees", to: "Priority Fees", flow: this.priority });
                                flows.push({ from: "Fees", to: "Base Fees", flow: this.base });
                                flows.push({ from: "Base Fees", to: "🔥 Burned", flow: this.base/2 });
                                flows.push({ from: "Base Fees", to: "1.3k+ Validators", flow: this.base/2 });
                                flows.push({ from: "Priority Fees", to: "1.3k+ Validators", flow: this.priority });

                            }
                            return flows;
                        })(),
                        colorFrom: c => getColor(c.dataset.data[c.dataIndex].from),
                        colorTo: c => getColor(c.dataset.data[c.dataIndex].to),
                        priority: {
                            "Jito DAO": 4,
                            "475k+ Stakers": 2,
                            "1.3k+ Validators": 3,
                            "🔥 Burned": 5,
                            'Fees': this.jito > this.priority ? 1 : 0,
                            'Jito Tips': this.jito > this.priority ? 0 : 1,
                        }

                    }
                ]
            },
            size: "min",
            options: {
                legend: {
                    labels: {
                        fontColor: "white",
                        fontSize: 14,
                    },

                }
            }
        }
        console.log(config)
        let c = new Chart(ctx, config);
        console.log(c)
    }
};
</script>

<style scoped>
.burns {
    max-height:400px;
    color: white;
}
#chart {
    max-height:400px;
}
</style>
